import { defineComponent, computed, openBlock, createElementBlock, createBlock, unref, mergeProps, createCommentVNode, withCtx, createTextVNode, toDisplayString, createVNode, createElementVNode } from "vue";
import { CdrLink, IconErrorFill } from "@rei/cedar";
import BuyBoxQuantity from "../BuyBoxQuantity/BuyBoxQuantity.mjs";
import BuyBoxColorSelector from "../BuyBoxColorSelector/BuyBoxColorSelector.mjs";
import BuyBoxSizeSelector from "../BuyBoxSizeSelector/BuyBoxSizeSelector.mjs";
import _sfc_main$1 from "../BuyBoxSkuSelector/BuyBoxSkuSelector.mjs";
import ClientOnly from "../../ClientOnly/ClientOnly.mjs";
/* empty css                                        */
const _hoisted_1 = {
  id: "product-color-size-component",
  class: "size-color"
};
const _hoisted_2 = {
  key: 3,
  class: "size-color__clearance-message"
};
const _hoisted_3 = {
  key: 0,
  class: "size-color__low-inventory"
};
const _hoisted_4 = {
  class: "size-color__quantity-input"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxSizeColor",
  props: {
    colorSelectorProps: {},
    errors: {},
    isLowInventory: {
      type: Boolean,
      default: false
    },
    quantity: {},
    sizeChart: {
      default: null
    },
    sizeSelectorProps: {},
    skuSelectorProps: {},
    selectedPriceClearanceMessage: {
      default: ""
    },
    enableSoldOutSizes: {
      type: Boolean
    }
  },
  emits: ["carouselHover", "colorHover", "colorUpdate", "metricsClick", "qtyUpdate", "registerRef", "sizeChartClick", "sizeHover", "sizeUpdate", "skuSelectUpdate"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const sizeColorClearanceMessage = computed(() => {
      if (props.selectedPriceClearanceMessage === "Discontinued") {
        return "is discontinued";
      }
      if (props.selectedPriceClearanceMessage === "Clearance") {
        return "is on clearance";
      }
      return "";
    });
    const handleColorChange = (data) => emit("colorUpdate", data);
    const handleSizeChartClick = () => emit("sizeChartClick");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.colorSelectorProps.showColors ? (openBlock(), createBlock(unref(BuyBoxColorSelector), mergeProps({
        key: 0,
        id: "color-thumbnails",
        class: "size-color__color"
      }, _ctx.colorSelectorProps, {
        error: _ctx.errors.color.hasError,
        "selected-price-clearance-message": _ctx.selectedPriceClearanceMessage,
        onColorUpdate: handleColorChange,
        onColorHover: _cache[0] || (_cache[0] = (data) => _ctx.$emit("colorHover", data)),
        onRegisterRef: _cache[1] || (_cache[1] = (ref) => _ctx.$emit("registerRef", ref))
      }), null, 16, ["error", "selected-price-clearance-message"])) : createCommentVNode("", true), _ctx.sizeSelectorProps.showSizes && !_ctx.skuSelectorProps.showSkuDropdown ? (openBlock(), createBlock(unref(BuyBoxSizeSelector), mergeProps({
        key: 1,
        class: "size-color__size"
      }, _ctx.sizeSelectorProps, {
        error: _ctx.errors.size.hasError,
        "grouped-sizes": _ctx.sizeSelectorProps.groupedSizes,
        onRegisterRef: _cache[2] || (_cache[2] = (ref) => _ctx.$emit("registerRef", ref)),
        onSizeHover: _cache[3] || (_cache[3] = (size) => _ctx.$emit("sizeHover", size)),
        onSizeUpdate: _cache[4] || (_cache[4] = (size) => _ctx.$emit("sizeUpdate", size))
      }), {
        link: withCtx(() => [_ctx.sizeChart ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          "data-ui": "size-chart-link",
          tag: "button",
          type: "button",
          "aria-haspopup": "dialog",
          onClick: handleSizeChartClick
        }, {
          default: withCtx(() => _cache[10] || (_cache[10] = [createTextVNode(" Size chart ")])),
          _: 1,
          __: [10]
        })) : createCommentVNode("", true)]),
        _: 1
      }, 16, ["error", "grouped-sizes"])) : createCommentVNode("", true), _ctx.skuSelectorProps.showSkuDropdown ? (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
        key: 2,
        class: "size-color__sku"
      }, _ctx.skuSelectorProps, {
        error: _ctx.errors.sku.hasError,
        skus: _ctx.skuSelectorProps.availableSkus,
        onRegisterRef: _cache[5] || (_cache[5] = (ref) => _ctx.$emit("registerRef", ref)),
        onSkuSelectUpdate: _cache[6] || (_cache[6] = (data) => _ctx.$emit("skuSelectUpdate", data))
      }), {
        link: withCtx(() => [_ctx.sizeChart ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          "data-ui": "size-chart-link",
          tag: "button",
          type: "button",
          "aria-haspopup": "dialog",
          onClick: handleSizeChartClick
        }, {
          default: withCtx(() => _cache[11] || (_cache[11] = [createTextVNode(" Size chart ")])),
          _: 1,
          __: [11]
        })) : createCommentVNode("", true)]),
        _: 1
      }, 16, ["error", "skus"])) : createCommentVNode("", true), _ctx.skuSelectorProps.showSkuDropdown && _ctx.selectedPriceClearanceMessage ? (openBlock(), createElementBlock("div", _hoisted_2, " Selected " + toDisplayString(_ctx.skuSelectorProps.label) + " " + toDisplayString(sizeColorClearanceMessage.value), 1)) : createCommentVNode("", true), createVNode(unref(ClientOnly), null, {
        default: withCtx(() => [_ctx.isLowInventory ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(IconErrorFill), {
          class: "size-color__low-inventory-icon"
        }), _cache[12] || (_cache[12] = createElementVNode("span", {
          class: "size-color__low-inventory-text"
        }, "Low inventory. Order soon!", -1))])) : createCommentVNode("", true)]),
        _: 1
      }), createElementVNode("div", _hoisted_4, [createVNode(unref(BuyBoxQuantity), {
        quantity: _ctx.quantity,
        error: _ctx.errors.quantity.hasError,
        onRegisterRef: _cache[7] || (_cache[7] = (ref) => _ctx.$emit("registerRef", ref)),
        onQtyUpdate: _cache[8] || (_cache[8] = (qty) => _ctx.$emit("qtyUpdate", qty)),
        onMetricsClick: _cache[9] || (_cache[9] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["quantity", "error"])])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxSizeColor2.mjs.map
